import Grid from './grid';
import 'dom-slider';

const Filters = {
  init: () => {
    Filters.filterTitles = document.querySelectorAll('.js-filterTitle');
    Filters.filterItems = document.querySelectorAll('.js-filterItem');
    Filters.filterDropdown = document.querySelectorAll('.js-filterDropdown');
    Filters.hiddenFilters = document.querySelectorAll('.js-hiddenFilter');
    Filters.applyFilter = document.querySelector('.js-applyFilter');
    Filters.deleteFilter = document.querySelector('.js-deleteFilter');
    Filters.gridItems = document.querySelectorAll('.js-gridItem');

    var filterValues = [];

    if (Filters.filterTitles) {
      Filters.filterTitles.forEach((title, i) => {
        title.addEventListener('click', (e) => {
          title.nextElementSibling.classList.add('select--open');
        })
        filterValues[i] = title.dataset.value;
      })
      Filters.apply(filterValues);
    }

    if (Filters.filterItems) {
      Filters.filterItems.forEach(item => {
        item.addEventListener('click', (e) => {
          Filters.change(item, filterValues);
        })
      })
    }

    if (Filters.deleteFilter) {
      Filters.deleteFilter.addEventListener('click', (e) => {
        Filters.delete(filterValues);
      })
    }

    if (Filters.applyFilter) {
      Filters.applyFilter.addEventListener('click', (e) => {
        Filters.apply(filterValues);
      })
    }

    document.addEventListener('click', function(e) {
      var dropdowns = document.querySelectorAll('.select--open');
      dropdowns.forEach(dropdown => {
        if (!dropdown.contains(e.target) && e.target.nextElementSibling != dropdown) dropdown.classList.remove('select--open');
      })
    })

  }, 

  change: (item, filterValues) => {
    let parent = item.parentElement;
    let indexParent = Array.from(Filters.filterTitles).indexOf(parent.previousElementSibling);
    parent.classList.remove('select--open');
    Array.from(parent.children).forEach(a => { a.classList.remove('select__item--selected') });
    item.classList.add('select__item--selected');
    parent.previousElementSibling.dataset.value = item.dataset.value;
    parent.previousElementSibling.innerHTML = item.innerHTML;
    filterValues[indexParent] = item.dataset.value;
    if (filterValues.every((val, i, arr) => val === arr[0]) && Filters.applyFilter.dataset.filter == '') {
      Filters.hiddenFilters.forEach(hidden => { hidden.classList.add('filter__title--hidden') });
    } else {
      Filters.hiddenFilters.forEach(hidden => { hidden.classList.remove('filter__title--hidden') });
    }
  },

  apply: (filterValues) => {
    let filterVal = filterValues.filter(val => val != 'all');
    Filters.applyFilter.dataset.filter = '';
    filterVal.forEach(filter => { Filters.applyFilter.dataset.filter += filter + ' '; })
    Filters.gridItems.forEach(item => {
      item.classList.add('grid__item--opacity');
      setTimeout(function(){
        item.classList.remove('grid__item--hidden');
        filterVal.forEach(filter => {
          if (!item.classList.contains(filter)) item.classList.add('grid__item--hidden');
        })
      }, 300) 
    })
    setTimeout(function(){
      if (document.querySelectorAll('.grid__item:not(.grid__item--hidden)').length < 1){
        document.querySelector('.grid__null').slideDown(300, 'cubic-bezier(0.645, 0.045, 0.355, 1)');
        Filters.gridItems.forEach(item => { item.classList.remove('grid__item--hidden') });
      } else {
        document.querySelector('.grid__null').slideUp(300, 'cubic-bezier(0.645, 0.045, 0.355, 1)'); 
      };
      Grid.init();
    }, 400) 
  },
  
  delete: (filterValues) => {
    if (Filters.filterDropdown) {
      Filters.filterDropdown.forEach(dropdown => {
        Filters.change(dropdown.children[0], filterValues);
        Filters.apply(filterValues);
      })
    }
  }
};

export default Filters;
